<template>
    <div class="page bg-fff text-center">
        <backTitleBar :isBackClose="true" :isLogOut="true"></backTitleBar>
        <img :src="mainImg" alt="" class="main-img">
        <div class="flex" style="margin-top: 3.1rem">
            <div class="flex1 text-center click" v-for="(item,$index) in shopTypeList" :key="$index" @click="chooseType(item)">
                <img :src="item.img" alt="" class="type-img">
                <div class="mt-20 fs-28 color-333">{{item.name}}</div>
            </div>
        </div>
<!--        <div class="fixed-text">-->
<!--            如需两种店铺类型，请开通两个商家账户-->
<!--        </div>-->
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import getAppParams from "@/mixins/getAppParams"
    export default {
        name: "chooseShopType",
        components:{backTitleBar},
        mixins: [getAppParams],
        data(){
            return{
                mainImg: require("../../../assets/images/shopRegister/heweogoLogo.png"),
                shopTypeList:[
                    {name:'实体门店入驻',img:require("../../../assets/images/shopRegister/type1.png"),shopType:3},
                    // {name:'线上商城入驻',img:require("../../../assets/images/shopRegister/type2.png"),shopType:4},
                ],
                shopId:this.$store.state.user.shopId,
                registerInfo:JSON.parse(localStorage.getItem('registerInfo')) || {},
                info:{},
            }
        },
        created() {
        },
        methods:{
            chooseType(data){
                this.info = {
                    shopId:this.shopId,
                    shopType : data.shopType
                };
                let formItem = Object.assign({}, this.registerInfo,this.info)
                localStorage.setItem('registerInfo', JSON.stringify(formItem))
                this.$router.push({name: 'shopRegisterBaseInfo'});
            },
        }
    }
</script>

<style scoped lang="scss">
    .main-img{
        width: 2.22rem;
        height: 2.44rem;
        margin-top: .85rem;
    }
    .type-img{
        width: 1.4rem;
        height: 1.4rem;
    }
    .fixed-text{
        position: fixed;
        width: 6.86rem;
        height: .64rem;
        text-align: center;
        line-height: .64rem;
        background:rgba(255,146,0,.1);
        border-radius: .12rem;
        left: .32rem;
        bottom: .5rem;
        font-size: .26rem;
        color: #FF9200;
    }
</style>



// WEBPACK FOOTER //
// chooseShopType.vue?61b7a8be